export const summaryRows: string[] = [
  'Volume 1 — Fundamentals',
  'Volume 2 — Components & Equipment',
  'Volume 3 — System Design & Sizing',
  'Volume 4 — Installation & Safety',
  'Volume 5 — Maintenance & Troubleshooting',
  'Volume 6 — Advanced Applications & Economics',
  'Bonus 1 — 100 Calculation Exercises',
  'Bonus 2 — 250 Technical Terms Dictionary',
  'Bonus 3 — 75 Troubleshooting Scenarios',
  'Bonus 4 — 150 Technical Q&A',
  'Bonus 5 — 30 Project Case Studies',
  '7-day money-back guarantee',
  'Instant access',
];
